// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1W4ii","title":"FrontImage_title__1i6aS"};